module.exports = __webpack_public_path__ + "img/map-down.d32465b8.svg";